import { ClientMessagesCard } from '../components/ClientMessagesCard';
import { MailServerCard } from '../components/MailServerCard';
import { useTenant } from '../hooks';
import { TabColumn } from './TabLayout';

/**
 * Tabblad Berichten: wat klanten vanzelf van het bedrijf krijgen, en de server
 * waarmee het de deur uit gaat. Het tabblad bestaat alleen voor wie instellingen
 * beheert (`settings-tabs.ts`).
 *
 * Onder elkaar: de berichten zijn een lange lijst, de mailserver een formulier
 * met twee kolommen velden. Naast elkaar zouden ze allebei te smal worden.
 */
export function MessagesTab({ canManage }: { canManage: boolean }) {
    const tenant = useTenant();

    return (
        <TabColumn>
            <ClientMessagesCard companyName={tenant.data?.name ?? ''} />
            <MailServerCard canManage={canManage} />
        </TabColumn>
    );
}
